const config = {
    themeName: "Metronic",
    themeVersion: "8.0.29",
    demo: "demo1",
    main: {
        type: "default",
        primaryColor: "#009EF7", // etkisiz
        logo: {
            dark: "/logo/virtara-light-logo.svg",
            light: "/logo/virtara-dark-logo.svg",
        },
    },
    loader: {
        logo: "/media/logos/logo-1-dark.svg",
        display: true,
        type: "default",
    },
    scrollTop: {
        display: true,
    },
    header: {
        display: true,
        menuIcon: "font",
        width: "fixed",
        fixed: {
            desktop: true,
            tabletAndMobile: true,
        },
    },
    toolbar: {
        display: true,
        width: "fixed",
        fixed: {
            desktop: false,
            tabletAndMobile: true,
        },
    },
    aside: {
        display: true,
        theme: "light",
        fixed: true,
        menuIcon: "font",
        minimized: false,
        minimize: true,
        hoverable: true,
    },
    content: {
        width: "fixed",
    },
    footer: {
        width: "fixed",
    },
};

export default config;
